<template>
  <span>{{ mydate }}</span>
</template>

<script>
import moment from "moment";

export default {
  props: {
    date: null,
    dateTime: null,
    format: {
      type: String,
      default: "datetime"  // "datetime" | "date" | "time"
    }
  },
  computed: {
    mydate() {
      if (this.date) {
        return moment(this.date).format("YYYY-MM-DD");
      }
      if (this.dateTime) {
        if (this.format === "date") return moment(this.dateTime).format("YYYY-MM-DD");
        if (this.format === "time") return moment(this.dateTime).format("HH:mm:ss");
        return moment(this.dateTime).format("YYYY-MM-DD HH:mm:ss");
      }
      return "unlimited";
    },
  },
};
</script>